
export const VERSION = '5.4.29'; // Update this manually on each release

